// extracted by mini-css-extract-plugin
module.exports = {"close":"HeaderClose-module--close--3z_Hy","closeActive":"HeaderClose-module--closeActive--3xuB5"};